import { Component } from '@angular/core';
import { AngularFireFunctions } from '@angular/fire/functions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'receipt2go-public';

  constructor(    private aff: AngularFireFunctions){
    // this.aff.useFunctionsEmulator('http://localhost:5001').then(() => console.log('Using functions emulator'));
  }

}
